var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b, _c, _d, _e, _f, _g, _h;
import { makeAutoObservable } from "mobx";
import { inject } from "tsyringe";
import { Money } from "../core";
import { perRestaurant } from "../di";
import { t, translate } from "../I18n";
import { LocalizationProvider } from "../locale";
import { DeliveryAddress, DeliveryAddressStatus, FulfillmentInstructions, FulfillmentInstructionsToken, PurchaseOrderPriceService, } from "../ordering";
import { maxPriceForFreeDelivery } from "./MaxPriceForFreeDelivery";
import { PCrossSellingBottomSheet } from "./PCrossSellingBottomSheet";
import { PPurchaseOrder } from "./PPurchaseOrder";
import { PPurchaseOrderUnavailabilityDetails } from "./PPurchaseOrderUnavailabilityDetails";
let PShortForOrderAlert = class PShortForOrderAlert {
    constructor(deliveryAddress, fulfillmentInstructions, deliveryAddressStatus, purchaseOrder, purchaseOrderPriceService, localizationProvider, purchaseOrderUnavailabilityDetails, crossSellingBottomSheet) {
        this.deliveryAddress = deliveryAddress;
        this.fulfillmentInstructions = fulfillmentInstructions;
        this.deliveryAddressStatus = deliveryAddressStatus;
        this.purchaseOrder = purchaseOrder;
        this.purchaseOrderPriceService = purchaseOrderPriceService;
        this.localizationProvider = localizationProvider;
        this.purchaseOrderUnavailabilityDetails = purchaseOrderUnavailabilityDetails;
        this.crossSellingBottomSheet = crossSellingBottomSheet;
        makeAutoObservable(this);
    }
    get isDelivery() {
        if (this.fulfillmentInstructions.type === "Online") {
            return (this.fulfillmentInstructions.fulfillmentMethodType === "Delivery" ||
                this.fulfillmentInstructions.fulfillmentMethodType ===
                    "NoContactDelivery");
        }
        return false;
    }
    get isAddressFilledIn() {
        return !this.deliveryAddress.streetAddress.isEmpty;
    }
    get isSomethingInCart() {
        return this.purchaseOrder.orderLines.length > 0;
    }
    get currentPrice() {
        return this.purchaseOrderPriceService.priceWithoutDelivery.finalValue;
    }
    get freeDeliveryThreshold() {
        if (this.deliveryAddressStatus.state.type === "RestaurantDelivers") {
            return this.deliveryAddressStatus.state.freeDeliveryThreshold;
        }
        else
            return null;
    }
    get howMuchToGetFreeDelivery() {
        if (this.currentPrice === null || this.freeDeliveryThreshold === null)
            return null;
        const remainder = this.freeDeliveryThreshold.sub(this.currentPrice);
        return remainder.leq(Money.zero()) ? null : remainder;
    }
    get howMuchToPlaceOrder() {
        var _a, _b;
        const money = (_b = (_a = this.purchaseOrderUnavailabilityDetails.insufficientOrderValueDetails) === null || _a === void 0 ? void 0 : _a.missingValue) !== null && _b !== void 0 ? _b : null;
        if (money !== null && money.gt(Money.zero())) {
            return money;
        }
        return null;
    }
    get isVisible() {
        return this.isVisibleFreeDelivery || this.isVisibleMinimumPrice;
    }
    get isVisibleFreeDelivery() {
        return (this.isAddressFilledIn &&
            this.isDelivery &&
            this.freeDeliveryThreshold != null &&
            this.isSomethingInCart &&
            this.howMuchToGetFreeDelivery !== null &&
            this.freeDeliveryThreshold.asNumber <=
                maxPriceForFreeDelivery(Skubacz.configuration.currency));
    }
    get isVisibleMinimumPrice() {
        return this.isSomethingInCart && this.howMuchToPlaceOrder !== null;
    }
    get reason() {
        if (this.isVisibleMinimumPrice) {
            return "notEnoughtForOrder";
        }
        else if (this.isVisibleFreeDelivery) {
            return "notEnoughtForFreeDelivery";
        }
        return "ok";
    }
    // Only for tracking (analytics) purposes
    get trackingPrice() {
        if (this.isVisibleMinimumPrice) {
            return this.howMuchToPlaceOrder;
        }
        else if (this.isVisibleFreeDelivery) {
            return this.howMuchToGetFreeDelivery;
        }
        return null;
    }
    get textMessage() {
        var _a, _b;
        if (this.isVisibleMinimumPrice) {
            return {
                message: translate(t.client.labels.min_order_value, {
                    amount: this.localizationProvider.formatPriceWithoutCents((_a = this.howMuchToPlaceOrder) === null || _a === void 0 ? void 0 : _a.roundUp()),
                }),
                severity: "danger",
            };
        }
        else if (this.isVisibleFreeDelivery) {
            return {
                message: translate(t.client.labels.free_delivery, {
                    amount: this.localizationProvider.formatPriceWithoutCents((_b = this.howMuchToGetFreeDelivery) === null || _b === void 0 ? void 0 : _b.roundUp()),
                }),
                severity: "warning",
            };
        }
        return null;
    }
};
PShortForOrderAlert = __decorate([
    perRestaurant(),
    __param(1, inject(FulfillmentInstructionsToken)),
    __metadata("design:paramtypes", [typeof (_a = typeof DeliveryAddress !== "undefined" && DeliveryAddress) === "function" ? _a : Object, typeof (_b = typeof FulfillmentInstructions !== "undefined" && FulfillmentInstructions) === "function" ? _b : Object, typeof (_c = typeof DeliveryAddressStatus !== "undefined" && DeliveryAddressStatus) === "function" ? _c : Object, typeof (_d = typeof PPurchaseOrder !== "undefined" && PPurchaseOrder) === "function" ? _d : Object, typeof (_e = typeof PurchaseOrderPriceService !== "undefined" && PurchaseOrderPriceService) === "function" ? _e : Object, typeof (_f = typeof LocalizationProvider !== "undefined" && LocalizationProvider) === "function" ? _f : Object, typeof (_g = typeof PPurchaseOrderUnavailabilityDetails !== "undefined" && PPurchaseOrderUnavailabilityDetails) === "function" ? _g : Object, typeof (_h = typeof PCrossSellingBottomSheet !== "undefined" && PCrossSellingBottomSheet) === "function" ? _h : Object])
], PShortForOrderAlert);
export { PShortForOrderAlert };
